
module.exports = {
    serverUrl: `http://211.54.28.111`,
    serverPrefixUrl: '/tree',
    loginMaintainenceTime: 10800,
    excuteAlarmTime : 300,
}